import * as Yup from 'yup';
import { tankTypes, transferTypes } from '../constants';

const base = {
  name: Yup.string().required('The transfer schedule name is required'),
  transfers: Yup.array().of(
    Yup.object().shape({
      name: Yup.string().required('The transfer step name is required'),
      days: Yup.number().required('The transfer days are required'),
      type: Yup.string().oneOf(transferTypes, 'The transfer type is not valid'),
      tankType: Yup.string().when('type', {
        is: 'TANK',
        then: Yup.string().oneOf(tankTypes, 'The tank type is not valid'),
        otherwise: Yup.string().nullable(true)
      }),
      vesselDescription: Yup.string().when('type', {
        is: 'VESSEL',
        then: Yup.string().required('The vessel details are required'),
        otherwise: Yup.string().nullable(true)
      }),
      locationId: Yup.number().when('type', {
        is: 'LOCATION',
        then: Yup.number().required('The transfer location is required'),
        otherwise: Yup.number().nullable(true)
      })
      // TODO - this needs to work!
      // nextTransferScheduleId: Yup.number().when(
      //   ['type', 'tankType', 'shouldAutocomplete'],
      //   (type, tankType, shouldAutocomplete, schema) => {
      //     if (type === 'TANK' && tankType === 'UNI_TANK' && shouldAutocomplete) {
      //       console.log('requres');
      //       return schema.required('The next transfer schedule is required');
      //     }
      //     console.log('no-pe');
      //     return schema.nullable(true);
      //   }
      // )
    })
  )
};

export const transferScheduleValidationSchema = Yup.object().shape(base);



// WEBPACK FOOTER //
// ./src/validation/transferSchedule.js